import { Notyf } from 'notyf';

class NotyfUtil {
    static createInstance() {
        return new Notyf({
            duration: 2000,
            ripple: true,
            position: {
                x: 'right',
                y: 'top'
            }
        });
    }

    static success(message) {
        const notyf = this.createInstance();
        notyf.success(message);
    }

    static error(message) {
        const notyf = this.createInstance();
        notyf.error(message);
    }

    static warning(message) {
        const notyf = this.createInstance();
        notyf.error(message);
    }
}

export default NotyfUtil;
